import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { subscriptionActions } from '..';
import { authActions } from '../../auth';
import { CalculateState, SubscriptionActions } from '../types';

const initialCalculateState: CalculateState = {
  data: null,
  error: null,
  isError: false,
  isPending: false
};

const calculateReducer: Reducer<typeof initialCalculateState, SubscriptionActions> = (
  state = initialCalculateState,
  action
) => {
  switch (action.type) {
    case getType(authActions.logoutAsync.success): {
      return initialCalculateState;
    }
    case getType(subscriptionActions.fetchSubscriptionCalculateAsync.request): {
      return {
        ...initialCalculateState,
        isError: false,
        isPending: true
      };
    }

    case getType(subscriptionActions.fetchSubscriptionCalculateAsync.success): {
      return {
        ...state,
        data: action.payload,
        isError: false,
        isPending: false
      };
    }

    case getType(subscriptionActions.fetchSubscriptionCalculateAsync.failure): {
      return {
        ...state,
        error: action.payload,
        isError: true,
        isPending: false
      };
    }

    default:
      return state;
  }
};

export default calculateReducer;
